import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { ParallaxProvider } from 'react-scroll-parallax';
import Navbar from "./components/Navbar";
import Music from './components/Pages/Music';
import Shows from './components/Pages/Shows';
import Media from './components/Pages/Media';
import Home from './components/Pages/Home';

function App() {

  return (
    <ParallaxProvider>
      <svg width="0" height="0" style={{ position: 'absolute' }}>
        <defs>
          <filter id="text-scratch">
            <feTurbulence type="fractalNoise" baseFrequency="0.85 0.25" numOctaves="4" seed="8" result="noise" />
            <feDisplacementMap in="SourceGraphic" in2="noise" scale="0.8" xChannelSelector="R" yChannelSelector="G" />
          </filter>
        </defs>
      </svg>
      <div className='flex flex-col min-h-screen'>
        <div className='sticky top-0 z-50'>
          <Navbar />
        </div>
        <div className='flex-1 flex flex-col'>
          <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="/Music" element={<Music />}></Route>
            <Route path="/Shows" element={<Shows />}></Route>
            <Route path="/Media" element={<Media />}></Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </div>
    </ParallaxProvider>
  );
}

export default App;
